import { render, staticRenderFns } from "./newsListDetail.vue?vue&type=template&id=d1771efa&"
import script from "./newsListDetail.vue?vue&type=script&lang=js&"
export * from "./newsListDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsListDetail.vue?vue&type=style&index=0&id=d1771efa&prod&lang=scss&"
import style1 from "./newsListDetail.vue?vue&type=style&index=1&id=d1771efa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports